/* Maps SSO LOS/business-unit full names (lowercased) to config.json' los - but only where overwrite is actually needed */
const losAlias = {
    "tax": "tax",
    "internal firm services": "ifs",
    "strategy&": "strategyand"
};

export default losAlias;
